var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicatesactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(199 275)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4758",
    "data-name": "Mask Group 4758",
    transform: "translate(-199 -275)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy",
    transform: "translate(167.426 258.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7328",
    "data-name": "Path 7328",
    d: "M45.238,20.4l1.377,1.377a1.377,1.377,0,0,1,.4.974V32.12A1.377,1.377,0,0,1,45.641,33.5H37.377A1.377,1.377,0,0,1,36,32.12V21.377A1.377,1.377,0,0,1,37.377,20h6.886a1.377,1.377,0,0,1,.974.4Z",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7329",
    "data-name": "Path 7329",
    d: "M204.264,123.432l.974.974a1.377,1.377,0,0,1,.4.974v9.366a1.377,1.377,0,0,1-1.377,1.377H196",
    transform: "translate(-154.491 -99.871)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatesactive);
export default __webpack_public_path__ + "static/media/duplicatesactive.7a31140164b966949b55c9be5111ee0a.svg";
export { ForwardRef as ReactComponent };